import template from './spending-types.html';
import controller from './spending-types.controller';

let spendingTypesComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default spendingTypesComponent;
